var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-plyr",style:(_vm.style)},[_c('audio',{ref:"audio",attrs:{"src":_vm.src,"controls":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }